export interface BonusText {
  description: string;
  heading: string;
  icon: string;
  id: number;
  name: string;
}

export interface TableColumn {
  field: string;
  header: string;
}

export abstract class CommitmentIcon {
  getIcon(leadSubject) {
    if (leadSubject && leadSubject.length > 0) {
      switch (leadSubject.toLowerCase().trim()) {
        case 'daily 5':
          return 'tasks';
        case 'creep mode':
          return 'tachometer-alt-slowest';
        case 'g.o.a.l.':
          return 'eye';
        case 'no fatigued driving':
          return 'alarm-snooze';
        case 'no distracted driving':
          return 'steering-wheel';
        case 'trip plan':
          return 'map-marked-alt';
        case 'proper speed':
          return 'tachometer-alt-fastest';
        case 'lane changes':
          return 'road';
        case 'following distance':
          return 'arrows-alt-h';
        case 'equipment inspection':
          return 'search';
        case '3 points of contact':
          return 'share-alt';
        case 'marco replies':
          return 'reply-all';
      }
    }
    return 'clipboard-check';
  }
}

export interface ICommitmentStatus {
  completionStatus: boolean;
  currentCommitment: boolean;
  leadDescription: string;
  leadSubject: string;
  leadId: number;
}
export interface IDriverCommitmentConfiguration {
  canChoose: boolean;
  driverChosen: boolean;
  forcedDefault: boolean;
  leadDescription: string;
  leadId: number;
  leadNumber: number;
  leadSubject: string;
  startDate: Date;
}

export class CommitmentStatus extends CommitmentIcon implements ICommitmentStatus {
  completionStatus: boolean;
  currentCommitment: boolean;
  leadDescription: string;
  leadSubject: string;
  leadId: number;

  constructor(payload: ICommitmentStatus) {
    super();
    this.completionStatus = payload.completionStatus;
    this.currentCommitment = payload.currentCommitment;
    this.leadDescription = payload.leadDescription;
    this.leadSubject = payload.leadSubject;
    this.leadId = payload.leadId;
  }
}

export class DriverCommitmentConfiguration
  extends CommitmentIcon
  implements IDriverCommitmentConfiguration
{
  canChoose: boolean;
  driverChosen: boolean;
  forcedDefault: boolean;
  leadDescription: string;
  leadId: number;
  leadNumber: number;
  leadSubject: string;
  startDate: Date;

  constructor(payload: IDriverCommitmentConfiguration) {
    super();
    this.canChoose = payload.canChoose;
    this.driverChosen = payload.driverChosen;
    this.forcedDefault = payload.forcedDefault;
    this.leadDescription = payload.leadDescription;
    this.leadId = payload.leadId;
    this.leadNumber = payload.leadNumber;
    this.leadSubject = payload.leadSubject;
    this.startDate = payload.startDate;
  }
}
